<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' width='550px' center
             @close='dialogClose' :close-on-click-modal='false'>
    <el-form ref='ruleForm' class='dialogForm' :model='form' label-width='110px' :rules='rules'>
      <el-form-item label='部门名称：' prop='depNm'>
        <el-input
          :style="'width:100%'"
          v-model='form.depNm'
          placeholder='请输入部门名称'
          autocomplete='off'
          size='small'
        />
      </el-form-item>
      <el-form-item label='负责人姓名：' prop='leader'>
        <el-input
          :style="'width:100%'"
          v-model='form.leader'
          placeholder='请输入部门负责人姓名'
          autocomplete='off'
          size='small'
        />
      </el-form-item>
      <el-form-item label='负责人电话：' prop='leaderPhone'>
        <el-input
          :style="'width:100%'"
          v-model='form.leaderPhone'
          placeholder='请输入部门负责人电话'
          autocomplete='off'
          size='small'
        />
      </el-form-item>
      <div class='btnContainer mt20'>
        <el-button size='small' class='searchBtn' :loading='buttonLoading' @click='dialogSubmit'>
          {{ dialogTitle === '新增部门' ? '新增' : '修改' }}
        </el-button>
        <el-button size='small' class='resetBtn' @click='dialogClose'>关闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import { addDepartment, editDepartment } from '@/service/basicfile';

  export default {
    leader: 'depNm-new',
    data() {
      const validateTell = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入部门负责人电话'));
        } else if (!(/^[1][3,4,5,7,8,9][0-9]{9}$/).test(value)) {
          callback(new Error('请输入正确的手机号'));
        } else {
          callback();
        }
      };
      return {
        dialogTitle: '',
        dialogVisible: false,
        buttonLoading: false,
        defaultForm: {},
        form: {
          depNm: '',
          leaderPhone: '',
          leader: '',
        },
        rules: {
          depNm: [
            {
              required: true,
              message: '请输入部门名称',
              trigger: 'blur',
            },
          ],
        },
      };
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      dialogOpen(title, item) {
        this.dialogTitle = title;
        if (item) this.form = JSON.parse(JSON.stringify(item));
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
        this.$refs.ruleForm.clearValidate();
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
      },
      dialogSubmit() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.buttonLoading = true;
            const res = this.dialogTitle === '新增部门' ? await addDepartment(this.form) : await editDepartment(this.form);
            this.buttonLoading = false;
            if (res.status !== 0) return this.$message.warning(res.message);
            this.$message.success(res.message);
            this.dialogClose();
            this.$emit('success');
          }
        });
      },
    },
  };
</script>

<style scoped>

</style>
